import { ServiceType } from '@/__generated__/globalTypes';
import { SetSeekerNameAction } from '@/components/pages/seeker/interfaces';
import { ABBREVIATION_BY_SERVICE_TYPE } from '@/constants';

export const getSetSeekerNameAction = (
  serviceType: ServiceType
): SetSeekerNameAction | undefined => {
  if (serviceType === ServiceType.SENIOR_CARE) {
    return 'setSeekerName';
  }

  if (serviceType in ABBREVIATION_BY_SERVICE_TYPE) {
    const prefix = ABBREVIATION_BY_SERVICE_TYPE[serviceType];

    return `${prefix.toLowerCase()}_setSeekerName` as SetSeekerNameAction;
  }

  return undefined;
};
